import { useQuery } from "@tanstack/react-query";
import { getDealManagers, getDealPipeline } from "@/api";

export const useDealPipeline = (managerId?: number | "all") => {
  const query = useQuery<any[]>({
    queryKey: ["dealPipeline", managerId ?? "me"],
    queryFn: () => getDealPipeline(managerId),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};

export const useDealManagers = () => {
  const query = useQuery<{ id: number; name: string; shortName: string }[]>({
    queryKey: ["dealManagers"],
    queryFn: getDealManagers,
    staleTime: 1000 * 60 * 30, // managers list rarely changes
  });

  return {
    ...query,
    data: query.data || [],
  }
};
